/**
 * ChatGPT / Grok 订阅选择器行的唯一运行时 guard。
 * IPC 只发对象；字符串行拒绝。档位只留在可选行上。
 */
import { THINKING_LEVELS, } from "./types/index.js";
const THINKING_LEVEL_SET = new Set(THINKING_LEVELS);
function isRecord(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
function isThinkingLevel(value) {
    return typeof value === "string" && THINKING_LEVEL_SET.has(value);
}
/** 词表外丢掉，重复丢掉，按 THINKING_LEVELS 排序。空则缺省。 */
function parseEffortLevels(raw) {
    if (!Array.isArray(raw))
        return undefined;
    const kept = new Set();
    for (const item of raw) {
        if (isThinkingLevel(item))
            kept.add(item);
    }
    if (kept.size === 0)
        return undefined;
    return THINKING_LEVELS.filter((level) => kept.has(level));
}
export function parseSubscriptionModelListItem(raw) {
    if (!isRecord(raw))
        return undefined;
    const modelIdRaw = Reflect.get(raw, "modelId");
    if (typeof modelIdRaw !== "string")
        return undefined;
    const modelId = modelIdRaw.trim();
    if (modelId.length === 0)
        return undefined;
    const liveOnly = Reflect.get(raw, "liveOnly") === true;
    const retired = Reflect.get(raw, "retired") === true;
    // 两个标记冲突时只留 liveOnly（不成行）。retired / liveOnly 不挂档位。
    if (liveOnly)
        return { modelId, liveOnly: true };
    if (retired)
        return { modelId, retired: true };
    const item = { modelId };
    const levels = parseEffortLevels(Reflect.get(raw, "effortLevels"));
    if (levels) {
        item.effortLevels = levels;
        const defaultEffort = Reflect.get(raw, "defaultEffort");
        if (isThinkingLevel(defaultEffort) && levels.includes(defaultEffort)) {
            item.defaultEffort = defaultEffort;
        }
    }
    if (item.effortLevels && Reflect.get(raw, "supportsUltra") === true)
        item.supportsUltra = true;
    const contextWindow = Reflect.get(raw, "contextWindow");
    if (typeof contextWindow === "number" && Number.isFinite(contextWindow) && contextWindow > 0) {
        item.contextWindow = contextWindow;
    }
    return item;
}
export function parseSubscriptionModelList(raw) {
    if (!Array.isArray(raw))
        return [];
    const out = [];
    for (const item of raw) {
        const row = parseSubscriptionModelListItem(item);
        if (row)
            out.push(row);
    }
    return out;
}
//# sourceMappingURL=subscription-model-list.js.map